import { date } from 'quasar'

export default (dateString = Date.now(), format = 'MMM DD, YYYY') =>
  date.formatDate(dateString, format)
